var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.pagedInfos),function(pInfo){return _c('div',{staticStyle:{"clear":"both"}},[_c('paged-infos',{attrs:{"init-filter":pInfo}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }